import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable()
export class MainGuard implements CanActivate {

    constructor(
        private router: Router,
        private message: NzMessageService,
        private localStorageService: LocalStorageService,
    ) {
    }

    canActivate() {
        if (this.localStorageService.get('token')) {
            return true;
        }
        
        this.message.create('info', 'Пожалуйста войдите в систему.');
        console.log('Пожалуйста войдите в систему.');
        this.router.navigate(['/login']);
        return false;
    }
}
